import React, { useContext, useEffect, useState } from 'react'

import { Link, NavLink, useNavigate } from 'react-router-dom'
import './styles.css'

import DashBoardIcon from '../icons/DashBoardIcon'
import TeamIcon from '../icons/team'
import SettingsIcon from '../icons/settings'
import LogoutIcon from '../icons/logout'
import AuthService from 'src/services/auth.service'
import userService from 'src/services/user.service'
import { parseJwt } from 'src/heplers'
import Spacer from '../components/Spacer'
import { UserViewContext } from 'src/App'
// import GetStartedIcon from '../icons/getStartedIcon'
import EmployeesPlatformIcon from '../icons/employees-platform'
import { Collapse } from '@mui/material'
import { WorkspaceSelect } from './workspace-slect'
import Logo from '../logo'
import OnboardingInfoCard from '../../views/Onboarding/OnboardingInfoCard'

export const specialCompanyIds = [
  '2ffd7fc7-6d0f-48b6-94c2-1aab115f1ae8',
  'c3964bfc-23b4-4e65-a7f1-149888adee6e',
  '4deba56b-8d8f-4240-ae96-cb9906949fd4'
]

function Nav() {
  const [user, setUser] = useState(null)

  const [riskManagementOpen, setRiskManagementOpen] = useState(
    ['/threats', '/workflows', '/data-leaks'].some(el => window.location.pathname.includes(el))
  )
  const [workforceOpen, setWorkforceOpen] = useState(
    ['/team', '/groups', '/companies'].some(el => window.location.pathname.includes(el))
  )
  const [simulationOpen, setSimulationOpen] = useState(
    ['/overview', '/templates', '/manual-simulation', '/new-campaign', '/edit-campaign', '/simulation-campaign'].some(
      el => window.location.pathname.includes(el)
    )
  )
  const [awarenessOpen, setAwarenessOpen] = useState(
    ['/microtraining', '/training-packages', '/security-assistant'].some(el => window.location.pathname.includes(el))
  )

  const [, setUserViewId] = useContext(UserViewContext)
  // const [onboarding] = useContext(OnboardingContext)

  const navigate = useNavigate()
  const handleLogout = () => {
    AuthService.logout()
      .then(() => {
        navigate('/login')
        localStorage.removeItem('user')
      })
      .catch(() => {
        localStorage.removeItem('user')
        navigate('/login')
      })
  }

  const handleShowAdmin = () => {
    if (user?.id) {
      setUserViewId(user.id)
    }
  }

  const userLocal = JSON.parse(localStorage.getItem('user'))

  useEffect(() => {
    if (!userLocal.accessToken) {
      navigate('/login')
      return
    }
    const userId = parseJwt(userLocal.accessToken).userId
    userService.getUser(userId).then(data => setUser(data.data))
  }, [])

  const handleOpenMenuGroup = (groupName, skipClose = false) => {
    setRiskManagementOpen(groupName == 'riskManagement' ? (skipClose ? true : !riskManagementOpen) : false)
    setWorkforceOpen(groupName == 'workforce' ? (skipClose ? true : !workforceOpen) : false)
    setSimulationOpen(groupName == 'simulation' ? (skipClose ? true : !simulationOpen) : false)
    setAwarenessOpen(groupName == 'awareness' ? (skipClose ? true : !awarenessOpen) : false)
  }

  const companyId = userLocal?.accessToken ? parseJwt(userLocal?.accessToken)?.companyId : null

  return (
    <div className='navigation column'>
      <NavLink className={'logo-link'} to={'/'}>
        <Logo />
      </NavLink>
      <OnboardingInfoCard />
      <WorkspaceSelect />
      {/*{!onboarding.done && (*/}
      {/*  <NavLink title='Get started' className={`nav-item row `} to={'/get-started'}>*/}
      {/*    <GetStartedIcon /> {<span>Get started</span>} <Spacer />{' '}*/}
      {/*    <span*/}
      {/*      style={{*/}
      {/*        fontSize: 12,*/}
      {/*        marginRight: 10,*/}
      {/*        color: '#6123FF'*/}
      {/*      }}*/}
      {/*    >*/}
      {/*      {onboarding?.activeStep - 1 || 0} of 4*/}
      {/*    </span>*/}
      {/*  </NavLink>*/}
      {/*)}*/}
      <NavLink title='Dashboard' className={`nav-item row `} to={'/'}>
        <DashBoardIcon /> {'Dashboard'}
      </NavLink>
      <div
        className={`row row-center nav-item${riskManagementOpen ? ' nav-separator-open' : ''}`}
        onClick={() => handleOpenMenuGroup('riskManagement')}
      >
        <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <mask id='mask0_25038_36748' maskUnits='userSpaceOnUse' x='0' y='0' width='10' height='20'>
            <rect width='10' height='20' fill='#D9D9D9' />
          </mask>
          <g mask='url(#mask0_25038_36748)'>
            <path
              opacity='0.2'
              d='M3.125 8.33333V3.75C3.125 3.58424 3.19085 3.42527 3.30806 3.30806C3.42527 3.19085 3.58424 3.125 3.75 3.125H16.25C16.4158 3.125 16.5747 3.19085 16.6919 3.30806C16.8092 3.42527 16.875 3.58424 16.875 3.75V8.33333C16.875 14.897 11.3042 17.0716 10.1919 17.4404C10.0675 17.4832 9.93246 17.4832 9.80811 17.4404C8.69578 17.0716 3.125 14.897 3.125 8.33333Z'
              fill='#1B1B26'
            />
          </g>
          <path
            d='M3.125 8.33333V3.75C3.125 3.58424 3.19085 3.42527 3.30806 3.30806C3.42527 3.19085 3.58424 3.125 3.75 3.125H16.25C16.4158 3.125 16.5747 3.19085 16.6919 3.30806C16.8092 3.42527 16.875 3.58424 16.875 3.75V8.33333C16.875 14.897 11.3042 17.0716 10.1919 17.4404C10.0675 17.4832 9.93246 17.4832 9.80811 17.4404C8.69578 17.0716 3.125 14.897 3.125 8.33333Z'
            stroke='#1B1B26'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </svg>

        <p>Risk Management</p>
        <Spacer />
        <svg
          className='nav-open-ico'
          width='16'
          height='16'
          viewBox='0 0 16 16'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path d='M3 5.33334L8 10.3333L13 5.33334' stroke='#76767D' strokeLinecap='round' strokeLinejoin='round' />
        </svg>
      </div>
      <Collapse onClick={() => handleOpenMenuGroup('riskManagement', true)} in={riskManagementOpen}>
        <NavLink title='Threats' className={`nav-item row in-collapse`} to={'/threats'}>
          {'Threats'}
        </NavLink>
        <NavLink title='Workflows' className={`nav-item row in-collapse`} to={'/workflows'}>
          {'Workflows'}
        </NavLink>
        <NavLink title='Breaches' className={`nav-item row in-collapse`} to={'/data-leaks'}>
          {'Data Leaks'}
        </NavLink>
      </Collapse>
      <div
        className={`row row-center nav-item${workforceOpen ? ' nav-separator-open' : ''}`}
        onClick={() => handleOpenMenuGroup('workforce')}
      >
        <TeamIcon />
        <p>Team</p>
        <Spacer />
        <svg
          className='nav-open-ico'
          width='16'
          height='16'
          viewBox='0 0 16 16'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path d='M3 5.33334L8 10.3333L13 5.33334' stroke='#76767D' strokeLinecap='round' strokeLinejoin='round' />
        </svg>
      </div>

      <Collapse onClick={() => handleOpenMenuGroup('workforce', true)} in={workforceOpen}>
        <NavLink title='Employees' className={`nav-item row in-collapse`} to={'/team'}>
          {'Employees'}
        </NavLink>
        <NavLink title='Groups' className={`nav-item row in-collapse`} to={'/groups'}>
          {'Groups'}
        </NavLink>
        {specialCompanyIds.includes(companyId) && (
          <NavLink title='Companies' className={`nav-item row in-collapse`} to={'/companies'}>
            {'Companies'}
          </NavLink>
        )}
      </Collapse>

      <div
        className={`row row-center nav-item${simulationOpen ? ' nav-separator-open' : ''}`}
        onClick={() => handleOpenMenuGroup('simulation')}
      >
        <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path
            opacity='0.2'
            d='M2.98267 3.78976L7.53064 15.9177C7.5755 16.0373 7.65595 16.1403 7.76114 16.2129C7.86633 16.2854 7.99121 16.3239 8.11897 16.3233C8.24673 16.3226 8.37123 16.2828 8.47569 16.2093C8.58015 16.1357 8.65956 16.0319 8.70322 15.9118L10.5252 10.9014C10.5564 10.8156 10.606 10.7376 10.6706 10.6731C10.7352 10.6085 10.8131 10.5588 10.899 10.5276L15.9094 8.70566C16.0295 8.662 16.1333 8.58259 16.2068 8.47813C16.2804 8.37367 16.3202 8.24918 16.3208 8.12142C16.3214 7.99366 16.2829 7.86877 16.2104 7.76358C16.1379 7.65839 16.0349 7.57794 15.9153 7.53308L3.78732 2.98511C3.67496 2.94297 3.55284 2.93407 3.43556 2.95948C3.31828 2.98488 3.21078 3.04352 3.12593 3.12837C3.04107 3.21323 2.98244 3.32072 2.95704 3.438C2.93163 3.55528 2.94053 3.6774 2.98267 3.78976Z'
            fill='#1B1B26'
          />
          <path
            d='M2.98267 3.78976L7.53064 15.9177C7.5755 16.0373 7.65595 16.1403 7.76114 16.2129C7.86633 16.2854 7.99121 16.3239 8.11897 16.3233C8.24673 16.3226 8.37123 16.2828 8.47569 16.2093C8.58015 16.1357 8.65956 16.0319 8.70322 15.9118L10.5252 10.9014C10.5564 10.8156 10.606 10.7376 10.6706 10.6731C10.7352 10.6085 10.8131 10.5588 10.899 10.5276L15.9094 8.70566C16.0295 8.662 16.1333 8.58259 16.2068 8.47813C16.2804 8.37367 16.3202 8.24918 16.3208 8.12142C16.3214 7.99366 16.2829 7.86877 16.2104 7.76358C16.1379 7.65839 16.0349 7.57794 15.9153 7.53308L3.78732 2.98511C3.67496 2.94297 3.55284 2.93407 3.43556 2.95948C3.31828 2.98488 3.21078 3.04352 3.12593 3.12837C3.04107 3.21323 2.98244 3.32072 2.95704 3.438C2.93163 3.55528 2.94053 3.6774 2.98267 3.78976Z'
            stroke='#1B1B26'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path d='M10.6704 10.6719L16.2497 16.2511' stroke='#1B1B26' strokeLinecap='round' strokeLinejoin='round' />
        </svg>

        <p>Simulation</p>
        <Spacer />
        <svg
          className='nav-open-ico'
          width='16'
          height='16'
          viewBox='0 0 16 16'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path d='M3 5.33334L8 10.3333L13 5.33334' stroke='#76767D' strokeLinecap='round' strokeLinejoin='round' />
        </svg>
      </div>

      <Collapse onClick={() => handleOpenMenuGroup('simulation', true)} in={simulationOpen}>
        <NavLink title='Templates' className={`nav-item row in-collapse`} to={'/templates'}>
          {'Templates'}
        </NavLink>
        <NavLink title='Manual Simulation V2' className={`nav-item row in-collapse`} to={'/simulation-campaign'}>
          {'Simulation Campaigns'}
        </NavLink>
      </Collapse>

      <div
        className={`row row-center nav-item${awarenessOpen ? ' nav-separator-open' : ''}`}
        onClick={() => handleOpenMenuGroup('awareness')}
      >
        <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path
            opacity='0.2'
            d='M8.9163 3.12381L2.04316 14.9982C1.93318 15.1882 1.87518 15.4038 1.875 15.6234C1.87482 15.8429 1.93246 16.0586 2.04212 16.2488C2.15179 16.439 2.30961 16.5969 2.4997 16.7068C2.6898 16.8166 2.90547 16.8744 3.125 16.8744H16.8713C17.0908 16.8744 17.3065 16.8166 17.4966 16.7068C17.6867 16.5969 17.8445 16.439 17.9542 16.2488C18.0638 16.0586 18.1215 15.8429 18.1213 15.6234C18.1211 15.4038 18.0631 15.1882 17.9531 14.9982L11.08 3.12381C10.9702 2.93411 10.8124 2.77661 10.6225 2.66712C10.4327 2.55763 10.2173 2.5 9.99815 2.5C9.77896 2.5 9.56363 2.55763 9.37374 2.66712C9.18386 2.77661 9.02611 2.93411 8.9163 3.12381Z'
            fill='#1B1B26'
          />
          <path d='M10 8.75V11.25' stroke='#1B1B26' strokeLinecap='round' strokeLinejoin='round' />
          <path
            d='M8.9163 3.12381L2.04316 14.9982C1.93318 15.1882 1.87518 15.4038 1.875 15.6234C1.87482 15.8429 1.93246 16.0586 2.04212 16.2488C2.15179 16.439 2.30961 16.5969 2.4997 16.7068C2.6898 16.8166 2.90547 16.8744 3.125 16.8744H16.8713C17.0908 16.8744 17.3065 16.8166 17.4966 16.7068C17.6867 16.5969 17.8445 16.439 17.9542 16.2488C18.0638 16.0586 18.1215 15.8429 18.1213 15.6234C18.1211 15.4038 18.0631 15.1882 17.9531 14.9982L11.08 3.12381C10.9702 2.93411 10.8124 2.77661 10.6225 2.66712C10.4327 2.55763 10.2173 2.5 9.99815 2.5C9.77896 2.5 9.56363 2.55763 9.37374 2.66712C9.18386 2.77661 9.02611 2.93411 8.9163 3.12381V3.12381Z'
            stroke='#1B1B26'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M10 15C10.5178 15 10.9375 14.5803 10.9375 14.0625C10.9375 13.5447 10.5178 13.125 10 13.125C9.48223 13.125 9.0625 13.5447 9.0625 14.0625C9.0625 14.5803 9.48223 15 10 15Z'
            fill='#1B1B26'
          />
        </svg>

        <p>Awareness</p>
        <Spacer />
        <svg
          className='nav-open-ico'
          width='16'
          height='16'
          viewBox='0 0 16 16'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path d='M3 5.33334L8 10.3333L13 5.33334' stroke='#76767D' strokeLinecap='round' strokeLinejoin='round' />
        </svg>
      </div>

      <Collapse onClick={() => handleOpenMenuGroup('awareness', true)} in={awarenessOpen}>
        <NavLink title='Training Topics' className={`nav-item row in-collapse`} to={'/microtraining'}>
          {'Training Topics'}
        </NavLink>

        <NavLink title='Training Packages' className={`nav-item row in-collapse`} to={'/training-packages'}>
          {'Training Packages'}
        </NavLink>
        <NavLink title='Security Assistant' className={`nav-item row in-collapse`} to={'/security-assistant'}>
          {'Security Assistant'}
        </NavLink>
      </Collapse>

      <div
        style={{
          margin: '10px 0px',
          background: '#76767D',
          width: '100%',
          height: 1,
          opacity: 0.2
        }}
      ></div>

      <Link target='_blank' title='CDC platform' className={`nav-item row `} to={'https://gallaghercdc.com/sign-in'}>
        <EmployeesPlatformIcon /> {'CDC platform'}
      </Link>

      <Link
        target='_blank'
        title='Employees platform'
        className={`nav-item row `}
        to={window._env_.REACT_USER_APP_HOST + '?accessToken=' + userLocal?.accessToken}
      >
        <EmployeesPlatformIcon /> {'Employees platform'}
      </Link>

      <NavLink title='Settings' className={`nav-item row `} to={'/settings'}>
        <SettingsIcon /> {'Settings'}
      </NavLink>

      <Spacer />

      {user && (
        <div className='row row-center'>
          <div onClick={handleShowAdmin} className='nav-user row'>
            <div className='avatar'>
              {(user.firstName ? user.firstName.slice(0, 1).toUpperCase() : '') +
                (user.lastName ? user.lastName.slice(0, 1).toUpperCase() : '')}
            </div>

            <div className='column'>
              <p className='name text-shrink-1' style={{ maxWidth: 127 }}>
                {user.firstName + ' ' + user?.lastName}
              </p>
            </div>
            <Spacer />
          </div>

          <div
            onClick={() => {
              window.open('https://helpcenter.cyberly.ai/')
            }}
            className={`nav-item-single-icon`}
            style={{ margin: 0 }}
          >
            <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
              <path
                opacity='0.2'
                d='M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z'
                fill='#1B1B26'
              />
              <path
                d='M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z'
                stroke='#1B1B26'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                d='M10 15C10.5178 15 10.9375 14.5803 10.9375 14.0625C10.9375 13.5447 10.5178 13.125 10 13.125C9.48223 13.125 9.0625 13.5447 9.0625 14.0625C9.0625 14.5803 9.48223 15 10 15Z'
                fill='#1B1B26'
              />
              <path
                d='M10 11.25V10.625C10.4326 10.625 10.8556 10.4967 11.2153 10.2563C11.575 10.016 11.8554 9.67433 12.021 9.27462C12.1866 8.87491 12.2299 8.43507 12.1455 8.01074C12.0611 7.58641 11.8527 7.19663 11.5468 6.89071C11.2409 6.58478 10.8511 6.37644 10.4268 6.29203C10.0024 6.20763 9.56259 6.25095 9.16288 6.41651C8.76317 6.58208 8.42153 6.86246 8.18116 7.22219C7.94079 7.58192 7.8125 8.00485 7.8125 8.4375'
                stroke='#1B1B26'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>
          </div>
          <div onClick={handleLogout} className={`nav-item-single-icon`} style={{ margin: 0 }}>
            <LogoutIcon />
          </div>
        </div>
      )}
    </div>
  )
}

export default Nav
